import { request } from '../../../../global/api/legacyApi'
import {
  HTTPMethod,
  type APIResponse,
} from '../../../../sharedLegacy/utils/api.types'

type SharingRequest = {
  live_id: number
  filename: string
  hidden_p: boolean
}

export async function startSharingAttachment(
  liveId: number,
  filename: string
): Promise<{}> {
  const { data } = await request<APIResponse>({
    method: HTTPMethod.GET,
    url: '/api/2/live/attachment/set-hidden',
    data: {
      live_id: liveId,
      filename,
      hidden_p: false,
    } satisfies SharingRequest,
  })
  return data
}

export async function stopSharingAttachment(
  liveId: number,
  filename: string
): Promise<{}> {
  const { data } = await request<APIResponse>({
    method: HTTPMethod.GET,
    url: '/api/2/live/attachment/set-hidden',
    data: {
      live_id: liveId,
      filename,
      hidden_p: true,
    } satisfies SharingRequest,
  })
  return data
}
